import { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import * as Icon from "react-bootstrap-icons";
import InputGroup from "react-bootstrap/InputGroup";

export default function ShareProject(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const textareaRef1 = useRef(null);
  const textareaRef2 = useRef(null);
  const copyTextToClipboard1 = () => {
    textareaRef1.current.select();
    document.execCommand("copy");
  };
  const copyTextToClipboard2 = () => {
    textareaRef2.current.select();
    document.execCommand("copy");
  };

  const preview = () => {
    console.log("ok");
    handleClose();
    window.open(
     
      ` https://ifcviewerleantower.parisashahbazi.com/${props.fileCodeParam}`,
      // `https://Ifcviewer.mizarei.com/${props.fileCodeParam}`,
      // `https://ifc.mirzaeei.com/${props.fileCodeParam}`,
      "_blank"
    );
  };

  console.log("props.fileCodeParam>>", props.fileCodeParam);

  return (
    <>
      <Button variant="primary" className="Share-btn" onClick={handleShow}>
        <Icon.ShareFill color="rgb(101, 101, 101)" size={"20px"} />
        <span>لینک انتشار</span>
      </Button>

      <Modal show={show} onHide={handleClose} dir="rtl">
        <Modal.Header>
          <Modal.Title className="Share-window-title">لینک انتشار</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="Share-window-form-label">
                با استفاده از کد زیر می توانید نمای سه بعدی را در وبسایت خود
                قرار دهید.
              </Form.Label>
              <InputGroup dir="ltr">
                <InputGroup.Text>
                  <div className="input-group-append">
                    <button
                      className="btn btn-secondary Copy-btn"
                      title="copy"
                      onClick={(e) => {
                        e.preventDefault();
                        copyTextToClipboard1();
                      }}
                    >
                      <Icon.Copy color="#1e56a0" />
                    </button>
                  </div>
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  rows={6}
                  aria-label="With textarea"
                  ref={textareaRef1}
                  value={`<iframe src=" https://ifcviewerleantower.parisashahbazi.com/${props.fileCodeParam}" allowFullScreen="true" webkitallowfullscreen="true" mozallowfulscreen="true" frameBorder={0} width="1024" height="768"></iframe>`}
                  // value={`<iframe src="https://Ifcviewer.mizarei.com/${props.fileCodeParam}" allowFullScreen="true" webkitallowfullscreen="true" mozallowfulscreen="true" frameBorder={0} width="1024" height="768"></iframe>`}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group controlId="formFileMultiple" className="mb-3">
              <Form.Label className="Share-window-form-label">
                با استفاده از لینک زیر می توانید صفحه پروژه را برای همکاران خود
                ارسال کنید.
              </Form.Label>
              <InputGroup dir="ltr">
                <InputGroup.Text>
                  <div className="input-group-append">
                    <button
                      className="btn btn-secondary Copy-btn"
                      title="copy"
                      onClick={(e) => {
                        e.preventDefault();
                        copyTextToClipboard2();
                      }}
                    >
                      <Icon.Copy color="#1e56a0" />
                    </button>
                  </div>
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  ref={textareaRef2}
                  rows={4}
                  aria-label="With textarea"
                
                  // value={`https://Ifcviewer.mizarei.com/${props?.fileCodeParam}`}
                  value={` https://ifcviewerleantower.parisashahbazi.com/${props?.fileCodeParam}`}
                />
              </InputGroup>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="Share-buttons">
          <div className="Share-buttons-right">
            <Button
              variant="light"
              className="Close-window-btn"
              onClick={handleClose}
            >
              بستن
            </Button>
          </div>
          <div className="Share-buttons-left">
            <Button variant="success" className="Preview-btn" onClick={preview}>
              پیش نمایش
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
